export interface MuniUserSettingsModel {
  defaultBenchmarkCurve: BenchmarkCurve;
  defaultFlexColumn: FlexColumn;
  defaultDealCardsView: DealCardsView;
}

export interface MuniUserSettingModel<T> {
  id: string;
  value: T;
}

export enum BenchmarkCurve {
  MmdInterpolated = 'MMD Interpolated',
  MmdCurrent = 'MMD Current',
  MmdAaaInsured = 'MMD AAA Insured',
  MmdAa = 'MMD AA',
  MmdA = 'MMD A',
  MmdBaa = 'MMD BAA',
  MmdPreRe = 'MMD Pre-Re',
}

export enum FlexColumn {
  Sector = 'Sector',
  Purpose = 'Purpose',
  ERP = 'Extraordinary Redemption Provision',
  BankQualified = 'Bank Qualified',
  SourceOfRepayment = 'Source of Repayment',
  IssueType = 'Issue Type',
  FirstCallDate = 'First Call Date',
  FirstCouponDate = 'First Coupon Date',
  DatedDate = 'Dated Date',
  ESG = 'ESG',
}

export type DealCardsView = true | false;
